module.exports = __webpack_public_path__ + "img/winner.c7461a19.png";